import { InjectionToken } from '@angular/core';
import { IAuthService } from './interfaces/auth-service.interface';

/**
 * Injection token for the authentication service.
 * This allows dependency injection to work with the factory pattern.
 */
export const AUTH_SERVICE = new InjectionToken<IAuthService>('AUTH_SERVICE');
